// extracted by mini-css-extract-plugin
export var layoutContainer = "_9c-0";
export var layoutContainerNoRounding = "_9c-6";
export var layoutContainerOpen = "_9c-5";
export var layoutContainerResizing = "_9c-1";
export var mainContent = "_9c-2";
export var resizeDivider = "_9c-3";
export var slidePanel = "_9c-4";